import { createClient } from '@supabase/supabase-js'
import { CLE_PUBLISHABLE, URL_SUPABASE } from './projet'

/**
 * Le MÊME projet Supabase que les autres surfaces SwiftDeliver.
 *
 * Adresse et clé publique : `./projet.ts` (valeur par défaut = production actuelle,
 * remplaçable au build par `VITE_SUPABASE_URL` / `VITE_SUPABASE_ANON_KEY`).
 * ⚠️ Le projet cloud a les clés JWT **legacy désactivées** : seule la clé
 * `publishable` y fonctionne. Elle est publique par conception — ce qu'un porteur
 * peut lire ou écrire est décidé par la RLS et par `is_platform_admin()` dans chaque
 * fonction. Aucune clé `service_role` ni `sb_secret_` ne doit apparaître ici.
 */
export { CLE_PUBLISHABLE, URL_SUPABASE }

export const supabase = createClient(URL_SUPABASE, CLE_PUBLISHABLE, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    /* Au retour de Google, supabase-js échange le code contre la session. */
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
})
